// 20.1.2.3 Number.isInteger(number)
var $export = require('./$.export');

$export($export.S, 'Number', {isInteger: require('./$.is-integer')});


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es6.number.is-integer.js
// module id = 215
// module chunks = 0